module.exports = __webpack_public_path__ + "resources/end-call-0d5e5b219cc3e818cf37f6e613753949.svg";